import checkIfStockOrderIsAvailable from './checkIfStockOrderIsAvailable';
import validate from '../validate';
import { Validator } from '../Validator';
import roundOrderValue from '../common/roundOrderValue';

export const configuration: Validator[] = [roundOrderValue, checkIfStockOrderIsAvailable];

export default validate(configuration);



// WEBPACK FOOTER //
// ./src/domain/orders/validators/stock/index.ts